import { render, staticRenderFns } from "./ListProductsComponent.vue?vue&type=template&id=dee91ad0&scoped=true&"
import script from "./ListProductsComponent.vue?vue&type=script&lang=js&"
export * from "./ListProductsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListProductsComponent.vue?vue&type=style&index=0&id=dee91ad0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee91ad0",
  null
  
)

export default component.exports